/* 车牌号前缀 */
export const carTitle = new Set(["京", "津", "冀", "晋", "蒙", "辽", "吉", "黑", "沪", "苏", "浙", '皖', "闽", "赣", "鲁", "豫", "鄂", "湘", "粤", "桂", "琼", "渝", "川", "贵", "云", "藏", "陕", "甘", "宁", "青", "新", "港", "澳", "台"]);

/** 车牌字母 */
export const carNum = new Set(["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]);

/* 省份车牌号前缀 */
export const carFirstTitle = [
  {
    title: '京',
    name: '北京市'
  },
  {
    title: '津',
    name: '天津市'
  },
  {
    title: '冀',
    name: '河北省'
  },
  {
    title: '晋',
    name: '山西省'
  },
  {
    title: '蒙',
    name: '内蒙古自治区'
  },
  {
    title: '辽',
    name: '辽宁省'
  },
  {
    title: '吉',
    name: '吉林省'
  },
  {
    title: '黑',
    name: '黑龙江省'
  },
  {
    title: '沪',
    name: '上海市'
  },
  {
    title: '苏',
    name: '江苏省'
  },
  {
    title: '浙',
    name: '浙江省'
  },
  {
    title: '皖',
    name: '安徽省'
  },
  {
    title: '闽',
    name: '福建省'
  },
  {
    title: '赣',
    name: '江西省'
  },
  {
    title: '鲁',
    name: '山东省'
  },
  {
    title: '豫',
    name: '河南省'
  },
  {
    title: '鄂',
    name: '湖北省'
  },
  {
    title: '湘',
    name: '湖南省'
  },
  {
    title: '粤',
    name: '广东省'
  },
  {
    title: '桂',
    name: '广西壮族自治区'
  },
  {
    title: '琼',
    name: '海南省'
  },
  {
    title: '川',
    name: '四川省'
  },
  {
    title: '贵',
    name: '贵州省'
  },
  {
    title: '云',
    name: '云南省'
  },
  {
    title: '渝',
    name: '重庆市'
  },
  {
    title: '藏',
    name: '西藏自治区'
  },
  {
    title: '陕',
    name: '陕西省'
  },
  {
    title: '甘',
    name: '甘肃省'
  },
  {
    title: '青',
    name: '青海省'
  },
  {
    title: '宁',
    name: '宁夏回族自治区'
  },
  {
    title: '新',
    name: '新疆维吾尔自治区'
  },
  {
    title: '港',
    name: '香港特别行政区'
  },
  {
    title: '澳',
    name: '澳门特别行政区'
  },
  {
    title: '台',
    name: '台湾省'
  }
];
